// @flow

import styled from 'styled-components';
import {
  Container,
  Content as BaseContent,
  Title as BaseTitle,
  Subtitle as BaseSubtitle,
} from './phone-input-screen.styles';
import {
  ACCENT_PURPLE,
  COUNTDOWN_BACKGROUND,
  BRAND_PURPLE,
  STEP_CARD_BACKGROUND,
} from '../brand';

export { Container };

export const Content = styled(BaseContent)`
  align-items: center;
  margin: 0 auto;
  text-align: center;
`;

export const Title = styled(BaseTitle)`
  margin-bottom: 16px;
  color: ${props => props.theme.colors.neutral[700]};
  font-size: 22px;
  line-height: 1.3;
`;

export const Subtitle = styled(BaseSubtitle)`
  max-width: none;
  margin-bottom: 8px;
  color: ${props => props.theme.colors.neutral[700]};
  font-size: 12px;
  font-weight: 600;
  text-align: center;
`;

export const Avatar = styled.img`
  width: 132px;
  height: 132px;
  margin-bottom: 16px;
`;

export const RemainingTime = styled.strong`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  margin-bottom: 16px;
  padding: 0 16px;
  border: 1px solid ${ACCENT_PURPLE};
  border-radius: 999px;
  color: ${ACCENT_PURPLE};
  background: ${COUNTDOWN_BACKGROUND};
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

export const ClockIcon = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const RemainingTimeText = styled.span`
  font-variant-numeric: tabular-nums;
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const StepCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1px solid ${props => props.theme.colors.neutral[150]};
  border-radius: 8px;
  text-align: left;
  background: ${STEP_CARD_BACKGROUND};
`;

export const StepNumber = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: ${props => props.theme.colors.neutral.white};
  background: ${BRAND_PURPLE};
  font-size: 14px;
  font-weight: 700;
`;

export const StepText = styled.p`
  color: ${props => props.theme.colors.neutral[700]};
  font-size: 14px;
  line-height: 1.45;
`;
